import { observer } from 'mobx-react-lite'
import { Typography } from '@mui/material'
import { AppBox } from 'src/component/common/analog/molecule/AppBox'
import { MAX_LEVEL_DESCRIPTION_LENGTH } from 'src/feature/dashboard/constants/skill-assessment-constants'
import { SkillSetLevel } from 'src/feature/skill-assessment/model/skill-assessment-model'
import { getCardRatingColor } from 'src/feature/my-team/util/skillGapUtils'
import { CharacterCountedTextField } from './CharacterCountedTextField'

type LevelItemProps = {
  level: SkillSetLevel
  index: number
  isSelected: boolean
  isEditing: boolean
  editedDescription: string
  onLevelClick: () => void
  onDescriptionChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

/**
 * Individual level item component displaying skill level description
 * Can switch between display mode and edit mode
 */
export const LevelItem = observer((props: LevelItemProps) => {
  const {
    level,
    index,
    isSelected,
    isEditing,
    editedDescription,
    onLevelClick,
    onDescriptionChange,
  } = props

  return (
    <AppBox sx={styles.levelRow}>
      {isEditing ? (
        <AppBox
          sx={styles.descriptionContainer}
          onClick={onLevelClick}
        >
          <CharacterCountedTextField
            fullWidth
            value={editedDescription}
            onChange={onDescriptionChange}
            onClick={e => e.stopPropagation()}
            variant='outlined'
            size='small'
            maxLength={MAX_LEVEL_DESCRIPTION_LENGTH}
          />
        </AppBox>
      ) : (
        <Typography
          variant='body2'
          sx={{
            cursor: 'pointer',
            color: isSelected ? getCardRatingColor(level.setLevel) : 'text.primary',
            lineHeight: 1.6,
            '&:hover': {
              textDecoration: 'underline',
            },
          }}
          onClick={onLevelClick}
        >
          {`${index + 1}. ${level.setLevelDescription}`}
        </Typography>
      )}
    </AppBox>
  )
})

const styles = {
  levelRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 0,
    width: '100%',
  },
  descriptionContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    flex: 1,
    borderRadius: '12px',
  },
}
